import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {filter} from 'rxjs';
import {DocumentDto} from '|api/document';
import {DocumentDetailService} from '|shared';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { CrossReferenceTableComponent } from '../../../document-shared/components/cross-reference-table/cross-reference-table.component';


@Component({
  selector: 'icz-document-detail-related-objects',
  templateUrl: './document-detail-related-objects.component.html',
  styleUrls: ['./document-detail-related-objects.component.scss'],
  imports: [CrossReferenceTableComponent]
})
export class DocumentDetailRelatedObjectsComponent implements OnInit {

  private documentDetailService = inject(DocumentDetailService);
  private destroyRef = inject(DestroyRef);

  document!: DocumentDto;

  ngOnInit() {
    this.documentDetailService.object$.pipe(
      takeUntilDestroyed(this.destroyRef),
      filter(Boolean),
    ).subscribe(document => {
      if (!this.document) {
        this.document = document;
      }
    });
  }

}
